import Vue from 'vue'
import router from './../router/index'
import {submitForm} from './formSubmit'

router.beforeEach(((to, from, next) => {
    let token = window.sessionStorage.getItem('token');
    if (token || to.path === '/') {
        next()
    } else {
        Vue.prototype.$eventBus.$emit('login')
    }
}))

function base64ToBlob(code) {
    let parts = code.split(';base64,');
    let contentType = parts[0].split(':')[1];
    let raw = window.atob(parts[1]);
    let rawLength = raw.length;

    let uInt8Array = new Uint8Array(rawLength);

    for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
    }
    return new Blob([uInt8Array], {type: contentType});
}

function downloadChart(fileName, content) {
    let time = getNowTimeString().split('-').join('');
    let aLink = document.createElement('a');
    let blob = base64ToBlob(content); // new Blob([content]);
    let evt = document.createEvent('HTMLEvents');
    evt.initEvent('click', true, true);// initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
    aLink.download = `${fileName}${time}`;
    aLink.href = URL.createObjectURL(blob);
    aLink.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window}));// 兼容火狐
}

function downloadImg(fileName, content) {
    let time = getNowTimeString().split('-').join('');
    let aLink = document.createElement('a');
    let evt = document.createEvent('HTMLEvents');
    evt.initEvent('click', true, true);// initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
    aLink.download = `${fileName}${time}`;
    aLink.href = content;
    aLink.target = '_blank';
    aLink.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window}));// 兼容火狐
}

function getNowTimeString(formatDate) {
    let now = new Date();
    let year = now.getFullYear();
    let month = now.getMonth() + 1;
    let day = now.getDate();
    month = month < 10 ? `0${month}` : month;
    day = day < 10 ? `0${day}` : day;
    if (formatDate) {
        return `${year}${month}${day}`
    } else {
        return `${year}-${month}-${day}`
    }

}

function contrastTime(val) {
    if (!val) return false;
    let now = new Date();
    let time = new Date(val);
    return now - time <= 1800 * 1000;
}

function randomString(num) {
    num = num || 10;
    let $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
    let maxPos = $chars.length;
    let pwd = '';
    for (let i = 0; i < num; i++) {
        pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd;
}

function isDateStr(data) {
    return isNaN(data) && !isNaN(Date.parse(data))
}

function dateFormat (fmt, str) { //author: meizz
    let now = ''
    if(str){
        now = new Date(str)
    }else {
        now = new Date()
    }
    let o = {
        "M+": now.getMonth() + 1, //月份
        "d+": now.getDate(), //日
        "h+": now.getHours(), //小时
        "m+": now.getMinutes(), //分
        "s+": now.getSeconds(), //秒
        "q+": Math.floor((now.getMonth() + 3) / 3), //季度
        "S": now.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (now.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        }
    }
    return fmt;
}


Vue.prototype.$base64ToBlob = base64ToBlob;
Vue.prototype.$downloadImg = downloadImg;
Vue.prototype.$downloadChart = downloadChart;
Vue.prototype.$timeString = getNowTimeString;
Vue.prototype.$contrastTime = contrastTime;
Vue.prototype.$randomString = randomString;
Vue.prototype.$isDateStr = isDateStr;
Vue.prototype.$dateFormat = dateFormat;
Vue.prototype.$validate = submitForm;
Vue.prototype.$eventBus = new Vue();


